export default "__VITE_ASSET__CRi3XgS4__"